import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface BackupVerifyRun {
  id: number;
  cluster: string;
  namespace: string;
  job_name: string;
  backup_name: string | null;
  started_at: string;
  finished_at: string;
  status: "success" | "failed";
  log_tail: string | null;
  bytes_size: number | null;
  created_at: string;
}

export interface BackupVerifyListResponse {
  items: BackupVerifyRun[];
  total: number;
}

export interface BackupVerifyLatestPerCluster {
  cluster: string;
  last_run: BackupVerifyRun | null;
  last_success: BackupVerifyRun | null;
}

export async function listBackupVerifyRuns(
  navigate: NavigateFunction,
  params?: { cluster?: string; status?: string; limit?: number; offset?: number },
): Promise<BackupVerifyListResponse> {
  const q = new URLSearchParams();
  if (params?.cluster) q.set("cluster", params.cluster);
  if (params?.status) q.set("status", params.status);
  q.set("limit", String(params?.limit ?? 50));
  q.set("offset", String(params?.offset ?? 0));
  const url = `${API_URL}/admin/backup-verify/?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) {
    throw new Error(
      `Erreur ${res?.status ?? "?"} lors du chargement des verify runs`,
    );
  }
  return res.json();
}

export async function getLatestBackupVerifyPerCluster(
  navigate: NavigateFunction,
): Promise<BackupVerifyLatestPerCluster[]> {
  const url = `${API_URL}/admin/backup-verify/latest`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) {
    throw new Error(
      `Erreur ${res?.status ?? "?"} lors du chargement du dernier verify`,
    );
  }
  return res.json();
}

export interface BackupVerifyTriggerOut {
  cluster: string;
  namespace: string;
  cronjob: string;
  job_name: string;
}

export async function triggerBackupVerify(
  navigate: NavigateFunction,
  cluster: string,
): Promise<BackupVerifyTriggerOut> {
  const url = `${API_URL}/admin/backup-verify/trigger`;
  const res = await apiFetch(
    url,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cluster }),
    },
    navigate,
  );
  if (!res?.ok) {
    let detail = `Erreur ${res?.status ?? "?"}`;
    try {
      const body = await res?.json();
      if (body?.detail) detail = `${detail} : ${body.detail}`;
    } catch {
      /* ignore parse error */
    }
    throw new Error(`Echec du déclenchement : ${detail}`);
  }
  return res.json();
}
